import { common } from '@/service/http';
import mainLayout from '@/layouts/main-layout/main-layout.vue';
import { createView, getViewMeta, listMetaViewsH } from '@/utils/meta-view';
import emptyLayout from '@/layouts/empty-layout/empty-layout.vue';

let listMetaRoutersData;
export const listMetaRouters = async () => {
    if (!listMetaRoutersData) {
        const listMetaRoutersResp = await common('meta./meta/ui-routes/get', {});
        if (listMetaRoutersResp.result) {
            listMetaRoutersData = listMetaRoutersResp.data;
        } else {
            return listMetaRoutersResp;
        }
    }
    return { result: true, data: listMetaRoutersData };
};

export const getRouter = async name => {
    const viewsData = await listMetaViewsH();
    const routesData = await listMetaRouters();

    const findInRoutersData = name => {
        for (const routData of routesData.data) {
            if (routData.route_name === name) {
                return routData;
            }
        }
        return undefined;
    };

    const routData = findInRoutersData(name);
    if (routData !== undefined) {
        const newRout = {
            path: routData.route_path,
            name: routData.route_name,
            meta: { requiresAuth: true, layout: mainLayout },
            component: await createView(await getViewMeta(viewsData, routData.view_name)),
        };
        return { result: true, data: newRout };
    }
    return { result: false };
};

const getLayout = name => {
    switch (name) {
        case 'mainLayout':
            return mainLayout;
        case 'emptyLayout':
            return emptyLayout;
        default:
            new Error('Error layout name 83d948d1-4de2-48ae-a4b1-c5f2a144e900');
    }
};
export const getRouteMeta = async (name, viewsData, routesData) => {
    const findInRoutersData = name => {
        for (const routData of routesData) {
            if (routData.route_name === name) {
                return routData;
            }
        }
        return undefined;
    };
    const routData = findInRoutersData(name);
    if (routData !== undefined) {
        const route = checkRoutePermission(routData);
        const meta = await getViewMeta(viewsData, route.view_name);
        const component = await createView(meta, route.accessDenided);
        const newRout = {
            path: route.route_path,
            name: route.route_name,
            meta: { requiresAuth: true, layout: getLayout(routData.layout) },
            viewId: route.view_name,
            component,
            is_child: routData.is_child,
            accessDenided: route.accessDenided,
        };
        return { result: true, data: newRout };
    }
    return { result: false };
};

const checkRoutePermission = route => {
    if (!route.accessDenided || route.is_child) {
        return route;
    }
    route.view_name = 'access-denied';
    return route;
};

export const getRouterDataByFullPath = async fullPath => {
    const routesData = await listMetaRouters();
    const matchArray = fullPath.match(/[^ ]+/g);
    if (matchArray?.length !== 1) {
        return { result: false };
    }
    const pathArray = matchArray[0].split('/');
    let routFind = false;
    for (const routData of routesData.data) {
        routFind = routData;
        const matchArrayRoutData = routData.route_path.match(/[^ ]+/g);
        if (matchArrayRoutData?.length !== 1) {
            return { result: false, err_uuid: 'e75aacdc-0e1e-4da4-b720-ab77875e97dc' };
        }
        const pathArrayRoutData = matchArrayRoutData[0].split('/');
        if (pathArrayRoutData?.length === pathArray?.length) {
            for (const index in pathArrayRoutData) {
                if (!pathArrayRoutData[index].startsWith(':')) {
                    if (pathArrayRoutData[index] !== pathArray[index]) {
                        routFind = undefined;
                    }
                }
            }
        } else {
            routFind = undefined;
        }
        if (routFind !== undefined) {
            return { result: true, data: routFind };
        }
    }
    return { result: false };
};
